import {
  Building2,
  CheckCircle2,
  Clock3,
  Mail,
  UserPlus,
} from "lucide-react";

import type { PlatformChurchDetail } from "@/api/platform";

type ChurchActivityPanelProps = {
  church: PlatformChurchDetail;
};

type TimelineEvent = {
  id: string;
  icon: React.ElementType;
  title: string;
  description: string;
  timestamp: string;
};

export function ChurchActivityPanel({
  church,
}: ChurchActivityPanelProps) {
  // Placeholder events until platform_activity API is connected
  const events: TimelineEvent[] = [
    {
      id: "1",
      icon: Building2,
      title: "Church provisioned",
      description: "Church workspace was successfully created.",
      timestamp: "Today • 10:42 AM",
    },
    {
      id: "2",
      icon: Mail,
      title: "Administrator invitation sent",
      description:
        church.invitation?.invited_email ??
        "Invitation sent to administrator.",
      timestamp: "Today • 10:45 AM",
    },
    {
      id: "3",
      icon: UserPlus,
      title: "Administrator assigned",
      description:
        church.administrators.length > 0
          ? `${church.administrators.length} administrator(s) assigned`
          : "No administrators assigned yet.",
      timestamp: "Yesterday",
    },
    {
      id: "4",
      icon: CheckCircle2,
      title: "Pilot request approved",
      description:
        "Church approved for onboarding into MinistryIQ.",
      timestamp: "2 days ago",
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-slate-950">
          Activity
        </h3>

        <p className="mt-1 text-sm text-slate-500">
          Platform activity and onboarding history.
        </p>
      </div>

      <div className="space-y-6">
        {events.map((event, index) => {
          const Icon = event.icon;

          return (
            <div
              key={event.id}
              className="relative flex gap-4"
            >
              {index < events.length - 1 && (
                <div className="absolute left-5 top-10 h-full w-px bg-slate-200" />
              )}

              <div className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-indigo-50">
                <Icon className="h-5 w-5 text-indigo-600" />
              </div>

              <div className="flex-1 rounded-xl border border-slate-200 bg-white p-4">
                <div className="flex items-center justify-between gap-3">
                  <h4 className="font-semibold text-slate-950">
                    {event.title}
                  </h4>

                  <div className="flex items-center gap-1 text-xs text-slate-500">
                    <Clock3 className="h-3.5 w-3.5" />
                    {event.timestamp}
                  </div>
                </div>

                <p className="mt-2 text-sm leading-6 text-slate-500">
                  {event.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}